enum EChargingSubTabItemNames {
    OVERVIEW = "overview",
    DEPARTURE = "departure",
    TIMER = "timer",
    PROFILES = "profiles",
    CLIMATE = "climate"
}

export { EChargingSubTabItemNames }
